import { Action } from './models';

export const currentActionNames = new Set<string | Action>();
